import { createFileRoute } from "@tanstack/react-router";
import { PosVNextLP } from "@/components/posvnext/PosVNextLP";
import profCaio from "@/assets/orto/prof-caio.jpg.asset.json";

const TITLE = "Pós em Prescrição de Exercícios para Fisioterapeutas | Versão B | FEO";
const DESC =
  "Versão B da LP: pós-graduação 100% online em Prescrição de Exercícios. 14 módulos, 360h, reconhecida pelo MEC. Prescreva com dose, carga e progressão.";
const URL = "https://fisioemortopedia.com.br/prescricao2";

export const Route = createFileRoute("/prescricao2")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: PrescricaoLP2,
});

function PrescricaoLP2() {
  return (
    <PosVNextLP
      product="prescricao"
      heroEyebrow="Pós-Graduação · 100% online · MEC"
      heroTitle="Prescrição de Exercícios com dose, carga e progressão de verdade"
      heroTitleHighlight="dose, carga e progressão"
      heroSubtitle="Aprenda a prescrever exercício com critério clínico, para cada paciente, em qualquer fase do tratamento. Sem chute, sem protocolo decorado, com raciocínio aplicado."
      promessas={[
        "Definir carga, série e repetição com base em evidência",
        "Progredir e regredir exercício conforme resposta do paciente",
        "Adaptar prescrição entre dor, força, hipertrofia e função",
        "Justificar cientificamente cada decisão de treino",
      ]}
      personas={[
        {
          titulo: "Fisio em reabilitação",
          desc: "Que quer parar de copiar protocolo e começar a prescrever com critério clínico.",
        },
        {
          titulo: "Fisio em consultório ou clínica",
          desc: "Que atende ortopedia, dor ou esporte e precisa dominar a dose do exercício.",
        },
        {
          titulo: "Fisio que treina pacientes",
          desc: "Que quer profundidade científica em treinamento de força aplicado à fisioterapia.",
        },
      ]}
      coordenadorNome="Caio Sain Vallio"
      coordenadorFoto={profCaio.url}
      coordenadorQuote="Exercício é remédio, mas só funciona se você acertar a dose. E acertar a dose é o que separa fisio bom de fisio mediano."
      coordenadorBio="Coordenador da pós em Prescrição de Exercícios da FEO. Pesquisador e referência em prescrição baseada em evidências, dosagem de treinamento e progressão de carga aplicada à reabilitação."
      ementaSubtitle="Grade completa, professores e cronograma da pós em Prescrição de Exercícios."
      whatsappUrl="https://nimble.li/o9yokpkm"
    />
  );
}
